import React, { useState, useRef, useEffect, Suspense } from 'react';
import { Smile } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import lazyRetry from '../utils/lazyRetry';

// Diferido: el picker (~110 KB) iba en el bundle principal de todos sólo para abrirse al
// hacer click. Ahora se baja la primera vez que alguien toca el botón.
const EmojiPicker = lazyRetry(() => import('emoji-picker-react'));

export default function EmojiPickerButton({ onEmojiSelect, size = 18, buttonClass, buttonStyle }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const { theme } = useAuth();

  useEffect(() => {
    if (!open) return;
    function handleClick(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <div ref={containerRef} style={{ position: 'relative', flexShrink: 0 }}>
      <button
        type="button"
        className={buttonClass || 'btn btn-ghost btn-icon btn-sm'}
        style={buttonStyle}
        onClick={() => setOpen(v => !v)}
        title="Emojis"
      >
        <Smile size={size} />
      </button>
      {open && (
        <div style={{ position: 'absolute', bottom: '100%', left: 0, zIndex: 9999, marginBottom: 4 }}>
          <Suspense fallback={<div className="card" style={{ margin: 0, width: 320, height: 400 }} />}>
          <EmojiPicker
            theme={theme === 'dark' ? 'dark' : 'light'}
            onEmojiClick={(emojiData) => { onEmojiSelect(emojiData.emoji); setOpen(false); }}
            width={320}
            height={400}
            searchPlaceholder="Buscar emoji..."
            previewConfig={{ showPreview: false }}
          />
          </Suspense>
        </div>
      )}
    </div>
  );
}
